import { Modal } from "./modal";

const Edit = { Modal };

export default Edit;
